import { ACTION_TYPE } from '../actions/actionTypes';

const { AGREEMENTS } = ACTION_TYPE;

const agreementReducer = (state = {}, action) => {
  switch (action.type) {
    case AGREEMENTS.UPDATE_AOF_KYC:
      return { ...state, aofKyc: action.payload };
    case AGREEMENTS.UPDATE_PROFILE:
      return { ...state, profile: action.payload };
    case AGREEMENTS.FETCH_AGREEMENTS:
      return {
        ...state,
        aofKyc: action.payload.aofKyc,
        profile: action.payload.profile,
        ndpf: action.payload.ndpf,
        proposedPlan: action.payload.proposedPlan,
        aofKycProfileSignature: action.payload.aofKycProfileSignature,
        ndpfProposedPlanSignature: action.payload.ndpfProposedPlanSignature,
        aofKycProfileTimestamp: action.payload.aofKycProfileTimestamp,
        ndpfProposedPlanTimestamp: action.payload.ndpfProposedPlanTimestamp,
      };
    case AGREEMENTS.ACKNOWLEDGEMENT_UNDERTAKING:
      return { ...state, ndpf: !state.ndpf };
    case AGREEMENTS.PROPOPOSED_PLAN:
      return { ...state, proposedPlan: !state.proposedPlan };
    case AGREEMENTS.SIGNATURE:
      return { ...state, [action.payload.name]: action.payload.value };
    case AGREEMENTS.TIMESTAMP_AOFKYC_PROFILE:
      return { ...state, aofKycProfileTimestamp: action.payload.aofKycProfileTimestamp, aofKycProfileTimestampUTC: action.payload.aofKycProfileTimestampUTC };
    case AGREEMENTS.TIMESTAMP_NDPF_PROPOSED_PLAN:
      return { ...state, ndpfProposedPlanTimestamp: action.payload.ndpfProposedPlanTimestamp, ndpfProposedPlanTimestampUTC: action.payload.ndpfProposedPlanTimestampUTC };
    case AGREEMENTS.IS_AGREEMENT_READY_FOR_QUALIFIED:
      return { ...state, isAgreementReadyForQualified: action.isAgreementReadyForQualified };
    case AGREEMENTS.IS_CUSTOM_AA_UPLOADED:
      return { ...state, customAssetAllocationUploaded: action.payload };
    default:
      return state;
  }
};

export default agreementReducer;
